import React, { Component } from 'react'

class Modal extends Component {
  componentDidMount() {
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this.handleEsc);
  }

  componentWillUnmount() {
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this.handleEsc);
  }

  handleEsc = (e) => {
    if (e.key === 'Escape') this.props.onClose();
  }

  handleOverlay = (e) => {
    if (e.target === e.currentTarget) this.props.onClose();
  }

  render() {
    const { children, wide } = this.props;
    return (
      <div className="modal-overlay" onClick={this.handleOverlay}>
        <div className={`modal-box${wide ? ' modal-box--wide' : ''}`}>
          <button className="modal-close" onClick={this.props.onClose} aria-label="Fermer">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
          {children}
        </div>
      </div>
    );
  }
}

export default Modal
